import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "firma";
var firmaService = {
    firmaTanimlama(firmaKodu, firmaAdi, siteAdi, vergiDairesi, vergiNo, slogan, keyword, siteAdresi, siteAdresi2, renk, eposta, eposta2, telefon, sabitTelefon, dahili, fax, adres, koordinat, map, sosyalMedya) {
        var userDataEstasMil = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstasMil"))));
        var param = {
            data: {
                yonetimId: userDataEstasMil["yonetimId"],
                userToken: userDataEstasMil["token"],
                firmaKodu: firmaKodu,
                firmaAdi: firmaAdi,
                siteAdi: siteAdi,
                vergiDairesi: vergiDairesi,
                vergiNo: vergiNo,
                slogan: slogan,
                keyword: keyword,
                siteAdresi: siteAdresi,
                siteAdresi2: siteAdresi2,
                renk: renk,
                eposta: eposta,
                eposta2: eposta2,
                telefon: telefon,
                sabitTelefon: sabitTelefon,
                dahili: dahili,
                fax: fax,
                adres: adres,
                koordinat: koordinat,
                map: map,
                sosyalMedya: sosyalMedya,
                methodName: "tanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    firmaDetay() {
        var userDataEstasMil = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstasMil"))));
        // console.log(userDataEstasMil);
        var param = {
            data: {
                yonetimId: userDataEstasMil["yonetimId"],
                userToken: userDataEstasMil["token"],
                firmaKodu: userDataEstasMil["firmaKodu"],
                methodName: "firmaDetay"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    firmaGuncelle(updateList) {
        var userDataEstasMil = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstasMil"))));
        var param = {
            data: {
                yonetimId: userDataEstasMil["yonetimId"],
                userToken: userDataEstasMil["token"],
                firmaKodu: userDataEstasMil["firmaKodu"],
                updateList: updateList,
                methodName: "firmaGuncelleme"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

};
export default firmaService